const AttorneyAgentIndividsQuery = (id) => {
    return `
    query {
      deleteAgentProfile(id: "${id}")
    }
    `
}

export default AttorneyAgentIndividsQuery